import ChatSidebarView from './ChatSidebarView';

export default ChatSidebarView;
